import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'

/**
 * This is the ObjectTextMessageStats type definition for the REST model.
 *
 * @typedef {Object} ObjectTextMessageStats
 * @property {Id} [objectId] - The ID of the object
 * @property {number} [receivedMessagesUnreadCount] - The number of unread text messages received from a device
 */
export const objectTextMessageStatsPropType = PropTypes.shape({
    objectId: idPropType,
    receivedMessagesUnreadCount: PropTypes.number
})
